export const ADD_ACTIVITY_TYPES = 'ADD_ACTIVITY_TYPES'
export const ADD_ACTIVITY_TYPE = 'ADD_ACTIVITY_TYPE'
export const ADD_ACTIVITY_ICONS = 'ADD_ACTIVITY_ICONS'
